import { Button, ButtonGroup } from '@mui/material/';
import { batch, useDispatch, useSelector } from 'react-redux';
import allActions from '../../actions/product_builder';
import ModalView from '../ModalView';
import { useState } from 'react';
import { Box } from '@mui/material';
import buttons from '../../styles/buttons.module.css';
import layout from '../../styles/layout.module.css';
import typography from '../../styles/typography.module.css';
import { useTranslation } from 'react-i18next';

const ResetButton = () => {
    const [openModal, setOpenModal] = useState(false);
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const currentModel = useSelector((state) => state.rootReducer.currentModel.currentModel);
    const shopifyModel = useSelector((state) =>
        state.shopifyReducer.ciems.find((ciem) => ciem.title === currentModel.name)
    );

    const resetPreview = () => {
        batch(() => {
            dispatch(allActions.shellActions.setActiveShell(currentModel.default_options.shell));
            dispatch(
                allActions.faceplateActions.setActiveFaceplateOption(
                    currentModel.default_options.faceplate
                )
            );
            dispatch(allActions.cableActions.setActiveCable(currentModel.default_options.cable));
            dispatch(
                allActions.customLayerActions.resetCustomLayer({
                    leftArtwork: {},
                    rightArtwork: {}
                })
            );
            dispatch(
                allActions.artworkActions.setActiveArtwork(currentModel.default_options.artwork)
            );
            dispatch(
                allActions.priceActions.setIEMPrice({ iem: currentModel, shopify: shopifyModel })
            );
            dispatch(allActions.priceActions.setRushProcessing(0));
        });
        setOpenModal(false);
    };
    const modalContent = (
        <Box>
            <p className={typography.modalResetText}>{t('reset_popup.reset_text')}</p>
            <p className={typography.modalResetText}>{t('reset_popup.reset_question')}</p>
        </Box>
    );

    const handleClose = () => {
        setOpenModal(false);
    };

    const action = (
        <Box className={layout.contentCenterBox}>
            <Button className={buttons.btnModalResetYes} onClick={() => resetPreview()}>
                {t('reset_popup.yes')}
            </Button>
            <Button className={buttons.btnModalResetNo} onClick={handleClose}>
                {t('reset_popup.no')}
            </Button>
        </Box>
    );
    return (
        <>
            <ButtonGroup className={layout.flexItem}>
                <Button
                    className={buttons.btnPillReset + ' ' + buttons.btnPill}
                    onClick={() => {
                        setOpenModal(true);
                    }}>
                    {t('settings.reset_design')}
                </Button>
            </ButtonGroup>
            <ModalView open={openModal} action={action} handleClose={handleClose}>
                {modalContent}
            </ModalView>
        </>
    );
};

export default ResetButton;
